let DictionaryPlugin = {
  install (Vue, options) {
    Vue.prototype.getDictionaryItems = function (dictionaryName) {
      return this.$store.state.dictionary.dictionaries[dictionaryName]
    }
  }
}
export default DictionaryPlugin



// WEBPACK FOOTER //
// ./src/plugins/DictionaryPlugin.js